import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useHistory } from "react-router-dom";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";

import { AuthContext } from "../../context/Auth/AuthContext";
import { ReportProblem, VisibilityOutlined, SwapHoriz, SwapHorizOutlined, Lock, LockOpen, AccessAlarm } from "@mui/icons-material";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { toast } from "react-toastify";
import { yellow } from "@mui/material/colors";
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import BulkTransferUserTicketsModal from "../BulkTransferUserTicketsModal";
import TicketViewOnlyModal from "../TicketViewOnlyModal";
import {
  Avatar,
  CardHeader,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Typography,
  Card,
  makeStyles,
  Container,
  Badge,
  Grid,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import { format, isSameDay, parseISO, differenceInMinutes } from "date-fns";
import { grey } from "@material-ui/core/colors";
import { getBackendUrl } from "../../config";

const backendUrl = getBackendUrl();

const useStyles = makeStyles((theme) => ({
  main: {
    display: "flex",
    justifyContent: "space-between",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  cardHeader: {
    width: "380px",
    minHeight: "100px",
    padding: 10,
    backgroundColor: "#DCDCDC",
  },
  cardHeaderPending: {
    width: "380px",
    minHeight: "100px",
    padding: 10,
    backgroundColor: "#C0C0C0",
  },
  cardHeaderNoResponse: {
    width: "380px",
    minHeight: "100px",
    padding: 10,
    backgroundColor: "#FFB74D",
  },
  card: {
    height: "300px",
    width: "380px",
    margin: "3px",
    borderRadius: 5,
    flex: 1,
    maxHeight: "100%",
    overflowY: "scroll",
    ...theme.scrollbarStyles,
    borderTop: "2px solid rgba(0, 0, 0, 0.12)",
  },
  changeWarap: {
    width: "380px",
    padding: 0,
    margin: 0,
  },
  pending: {
    color: yellow[600],
    fontSize: "20px",
  },
  connectionTag: {
    background: "green",
    color: "#FFF",
    marginRight: 1,
    padding: 1,
    fontWeight: "bold",
    // paddingLeft: 5,
    // paddingRight: 5,
    borderRadius: 3,
    fontSize: "0.6em",
    // whiteSpace: "nowrap"
  },
  lastMessageTime: {
    justifySelf: "flex-end",
    textAlign: "right",
    position: "relative",
    // top: -30,
    marginRight: "1px",
    color: grey[400],
  },

  lastMessageTimeUnread: {
    justifySelf: "flex-end",
    textAlign: "right",
    position: "relative",
    // top: -30,
    color: "green",
    fontWeight: "bold",
    marginRight: "1px",
  },
  pending: {
    color: yellow[600],
    fontSize: "20px",
  },
  noResponse: {
    color: "#FF6B6B",
    fontSize: "20px",
  },
}));

const DashboardManage = () => {
  const classes = useStyles();
  const history = useHistory();
  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);

  const [tickets, setTickets] = useState([]);
  const [update, setUpdate] = useState(false);
  const [ticketNot, setTicketNot] = useState(0);
  const companyId = user.companyId;
  
  // Estado para controlar o modal de transferência
  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  
  // Estado para controlar o modal de transferência em lote
  const [bulkTransferModalOpen, setBulkTransferModalOpen] = useState(false);
  const [selectedUserForBulkTransfer, setSelectedUserForBulkTransfer] = useState(null);

  // Estado para controlar o modal de visualização
  const [viewTicketModalOpen, setViewTicketModalOpen] = useState(false);
  const [selectedTicketId, setSelectedTicketId] = useState(null);

  const userQueueIds = user?.queues?.map((q) => q.id) || [];
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);

  const handleOpenTransferModal = (ticket) => {
    setSelectedTicket(ticket);
    setTransferTicketModalOpen(true);
  };

  const handleCloseTransferModal = () => {
    setSelectedTicket(null);
    setTransferTicketModalOpen(false);
  };

  const handleOpenBulkTransferModal = (userInfo) => {
    setSelectedUserForBulkTransfer(userInfo);
    setBulkTransferModalOpen(true);
  };

  const handleCloseBulkTransferModal = () => {
    setSelectedUserForBulkTransfer(null);
    setBulkTransferModalOpen(false);
  };

  const handleOpenViewTicketModal = (ticketId) => {
    setSelectedTicketId(ticketId);
    setViewTicketModalOpen(true);
  };

  const handleCloseViewTicketModal = () => {
    setSelectedTicketId(null);
    setViewTicketModalOpen(false);
  };

  const handleBulkTransferSuccess = async () => {
    // Recarregar os dados após transferência
    try {
      const { data } = await api.get("/usersMoments");
      setTickets(data);
      setUpdate(!update);
    } catch (err) {
      if (err.response?.status !== 500) {
        toastError(err);
      } else {
        toast.error(`${i18n.t("frontEndErrors.getUsers")}`);
      }
    }
  };

  const handleToggleLock = async (userId, currentLockStatus) => {
    try {
      const { data } = await api.put(`/users/${userId}/toggle-lock`);
      toast.success(`Atendente ${data.isLocked ? 'bloqueado' : 'desbloqueado'} com sucesso!`);
      
      // Recarregar dados completos para garantir consistência
      try {
        const { data: updatedTickets } = await api.get("/usersMoments");
        setTickets(updatedTickets);
        setUpdate(prev => !prev);
      } catch (reloadErr) {
        console.error("Erro ao recarregar tickets:", reloadErr);
      }
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/usersMoments");
        setTickets(data);
        setUpdate(!update);
      } catch (err) {
        if (err.response?.status !== 500) {
          toastError(err);
        } else {
          toast.error(`${i18n.t("frontEndErrors.getUsers")}`);
        }
      }
    })();
  }, []);

  useEffect(() => {
    const companyId = user.companyId;
    // const socket = socketManager.GetSocket();

    // const onConnect = () => {
    //   socket.emit("joinChatBox", `${ticketId}`);
    // }
    const onAppMessage = (data) => {
      if (
        data.action === "create" ||
        data.action === "update" ||
        data.action === "delete"
      ) {
        (async () => {
          try {
            const { data } = await api.get("/usersMoments");
            setTickets(data);
            setUpdate(!update);
          } catch (err) {
            if (err.response?.status !== 500) {
              toastError(err);
            } else {
              toast.error(`${i18n.t("frontEndErrors.getUsers")}`);
            }
          }
        })();
      }
    };

    // Removido listener onUserUpdate para evitar erros de sincronização
    // A atualização de lock status será vista ao recarregar a página ou via UserLockOverlay

    // socket.on("connect", onConnect);
    socket.on(`company-${companyId}-ticket`, onAppMessage);
    socket.on(`company-${companyId}-appMessage`, onAppMessage);
    // socket.on(`company-${companyId}-user`, onUserUpdate); // Desabilitado temporariamente

    return () => {
      // socket.off("connect", onConnect);
      socket.off(`company-${companyId}-ticket`, onAppMessage);
      socket.off(`company-${companyId}-appMessage`, onAppMessage);
      // socket.off(`company-${companyId}-user`, onUserUpdate);
    };
  }, [socket]);

  const Moments = useMemo(() => {
    if (tickets && tickets.length > 0) {
      const ticketsByUser = tickets.reduce((userTickets, ticket) => {
        // Validação de segurança
        if (!ticket || !ticket.user) {
          return userTickets;
        }

        const user = ticket.user;
        const userIndex = userTickets.findIndex(
          (group) => group && group.user && group.user.id === user.id
        );
        
        if (userIndex === -1) {
          userTickets.push({
            user,
            userTickets: [ticket],
          });
        } else {
          userTickets[userIndex].userTickets.push(ticket);
        }
        
        return userTickets;
      }, []);

      return ticketsByUser.map((group, index) => {
        // Validação de segurança para evitar erros
        if (!group || !group.user || !group.userTickets) {
          return null;
        }

        // Calcular ativos e receptivos baseado em isActiveDemand
        // isActiveDemand = true -> Ativo (demanda ativa/proativa do atendente)
        // isActiveDemand = false -> Receptivo (demanda passiva/receptiva do cliente)
        const activeCount = group.userTickets.filter(t => t && t.isActiveDemand === true).length;
        const receptiveCount = group.userTickets.filter(t => t && t.isActiveDemand === false).length;
        
        return (
        <Grid item key={index}>
          <div padding={20} className={classes.main} key={index}>
            <div className={classes.changeWarap}>
              <Paper elevation={3} className={classes.cardHeader}>
                <CardHeader
                  style={{ maxWidth: "380px", width: "100%" }}
                  avatar={
                    <Avatar
                      alt={`${group.user.profileImage}`}
                      src={
                        group.user.profileImage
                          ? `${backendUrl}/public/company${companyId}/user/${group.user.profileImage}`
                          : null
                      }
                    />
                  }
                  title={
                    <span>
                      {group?.user?.name || `${i18n.t("momentsUser.pending")}`}{" "}
                      <br />
                      {`${i18n.t("momentsUser.services")} ${
                        group.userTickets?.length
                      }`}
                      <br />
                      <span style={{ fontSize: '0.85em', color: '#666' }}>
                        Ativo: {activeCount} | Receptivo: {receptiveCount}
                      </span>
                    </span>
                  }
                  action={
                    user.profile === "admin" && (
                      <>
                        <Tooltip title={group.user.isLocked ? "Desbloquear atendente" : "Bloquear atendente"}>
                          <IconButton
                            size="small"
                            onClick={() => handleToggleLock(group.user.id, group.user.isLocked)}
                            style={{ color: group.user.isLocked ? '#f44336' : '#666' }}
                          >
                            {group.user.isLocked ? <Lock /> : <LockOpen />}
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Transferir todos os tickets">
                          <IconButton
                            size="small"
                            onClick={() => handleOpenBulkTransferModal({
                              id: group.user.id,
                              name: group.user.name
                            })}
                          >
                            <SwapHorizOutlined />
                          </IconButton>
                        </Tooltip>
                      </>
                    )
                  }
                />
              </Paper>
              <Paper square elevation={1} className={classes.card}>
                {group.userTickets && Array.isArray(group.userTickets) && group.userTickets.map((ticket) => (
                  <List style={{ paddingTop: 0 }} key={ticket.id}>
                    <ListItem dense button>
                      <ListItemAvatar>
                        <Avatar
                          alt={`${ticket.contact.urlPicture}`}
                          src={`${ticket.contact.urlPicture}`}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        disableTypography
                        primary={
                          ticket?.contact?.name?.length > 30
                            ? ticket?.contact?.name.substring(0, 25) + "..."
                            : ticket?.contact?.name
                        }
                        secondary={
                          <Fragment>
                            <div>
                              <Typography
                                style={{ display: "inline" }}
                                component="span"
                                variant="body2"
                              >
                                {`${
                                  ticket.lastMessage?.length > 30
                                    ? String(ticket.lastMessage).substring(
                                        0,
                                        27
                                      ) + "..."
                                    : ticket.lastMessage
                                }`}
                              </Typography>
                            </div>
                            <Badge className={classes.connectionTag}>
                              {ticket?.whatsapp?.name}
                            </Badge>
                            <Badge
                              style={{
                                backgroundColor:
                                  ticket.queue?.color || "#7c7c7c",
                              }}
                              className={classes.connectionTag}
                            >
                              {ticket.queue?.name.toUpperCase() ||
                                `${i18n.t("momentsUser.noqueue")}`}
                            </Badge>
                          </Fragment>
                        }
                      />
                      <Typography
                        className={
                          Number(ticket.unreadMessages) > 0
                            ? classes.lastMessageTimeUnread
                            : classes.lastMessageTime
                        }
                        component="span"
                        variant="body2"
                      >
                        {isSameDay(parseISO(ticket.updatedAt), new Date()) ? (
                          <>{format(parseISO(ticket.updatedAt), "HH:mm")}</>
                        ) : (
                          <>
                            {format(parseISO(ticket.updatedAt), "dd/MM/yyyy")}
                          </>
                        )}
                      </Typography>
                      {(user.profile === "admin" ||
                        ticket.userId === user.id) && (
                        <>
                          <Tooltip title="Transferir Ticket">
                            <SwapHoriz
                              onClick={() => handleOpenTransferModal(ticket)}
                              fontSize="small"
                              style={{
                                color: grey[500],
                                cursor: "pointer",
                                marginRight: 5,
                                bottom: "-15px",
                              }}
                            />
                          </Tooltip>
                          <Tooltip title="Visualizar Mensagens">
                            <VisibilityOutlined
                              onClick={() => handleOpenViewTicketModal(ticket.id)}
                              fontSize="small"
                              style={{
                                color: grey[500],
                                cursor: "pointer",
                                marginRight: 5,
                                bottom: "-15px",
                              }}
                            />
                          </Tooltip>
                        </>
                      )}
                    </ListItem>
                    <Divider variant="inset" component="li" />
                  </List>
                ))}
              </Paper>
            </div>
          </div>
        </Grid>
        );
      }).filter(Boolean); // Remove nulls/undefined
    } else {
      return null;
    }
  }, [tickets, update, user.profile]);

  const MomentsPending = useMemo(() => {
    if (tickets && tickets.length > 0) {
      const pendingTickets = tickets.filter((ticket) => !ticket.user);

      return (
        <Grid item>
          <div className={classes.main}>
            <div padding={2} className={classes.changeWarap}>
              <Paper elevation={3} className={classes.cardHeaderPending}>
                <CardHeader
                  style={{ maxWidth: "380px", width: "100%" }}
                  avatar={<Avatar />}
                  title={
                    <span>
                      {`${i18n.t("momentsUser.pending")}`}
                      <ReportProblem className={classes.pending} />
                      <div>
                        {i18n.t("momentsUser.services")}{" "}
                        {pendingTickets?.length}
                      </div>
                    </span>
                  }
                />
              </Paper>
              <Paper square elevation={1} className={classes.card}>
                {pendingTickets && Array.isArray(pendingTickets) && pendingTickets.map((ticket) => (
                  <List style={{ paddingTop: 0 }} key={ticket.id}>
                    <ListItem dense button>
                      <ListItemAvatar>
                        <Avatar
                          alt={`${ticket.contact.urlPicture}`}
                          src={`${ticket.contact.urlPicture}`}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        disableTypography
                        primary={ticket?.contact?.name}
                        secondary={
                          <Fragment>
                            <div>
                              <Typography
                                style={{ display: "inline" }}
                                component="span"
                                variant="body2"
                              >
                                {`${
                                  ticket.lastMessage?.length > 30
                                    ? String(ticket.lastMessage).substring(
                                        0,
                                        27
                                      ) + "..."
                                    : ticket.lastMessage
                                }`}
                              </Typography>
                            </div>
                            <Badge className={classes.connectionTag}>
                              {ticket?.whatsapp?.name}
                            </Badge>
                            <Badge
                              style={{
                                backgroundColor:
                                  ticket.queue?.color || "#7c7c7c",
                              }}
                              className={classes.connectionTag}
                            >
                              {ticket.queue?.name.toUpperCase() ||
                                `${i18n.t("momentsUser.noqueue")}`}
                            </Badge>
                          </Fragment>
                        }
                      />
                      <Typography
                        className={
                          Number(ticket.unreadMessages) > 0
                            ? classes.lastMessageTimeUnread
                            : classes.lastMessageTime
                        }
                        component="span"
                        variant="body2"
                      >
                        {isSameDay(parseISO(ticket.updatedAt), new Date()) ? (
                          <>{format(parseISO(ticket.updatedAt), "HH:mm")}</>
                        ) : (
                          <>
                            {format(parseISO(ticket.updatedAt), "dd/MM/yyyy")}
                          </>
                        )}
                      </Typography>
                    </ListItem>
                    <Divider variant="inset" component="li" />
                  </List>
                ))}
              </Paper>
            </div>
          </div>
        </Grid>
      );
    } else {
      return null;
    }
  }, [tickets, update, user.profile]);

  const MomentsNoResponse = useMemo(() => {
    if (tickets && tickets.length > 0) {
      const now = new Date();
      
      // ✅ Função helper para determinar se a última mensagem foi do cliente
      const isLastMessageFromClient = (ticket) => {
        // 1️⃣ Primeiro, verificar o campo fromMe do ticket (atualizado para tickets novos)
        if (ticket.fromMe === true) {
          return false; // Última mensagem foi do atendente
        }
        if (ticket.fromMe === false) {
          return true; // Última mensagem foi do cliente
        }
        
        // 2️⃣ Se fromMe do ticket for null/undefined (tickets antigos), 
        // verificar a última mensagem no array messages
        if (ticket.messages && Array.isArray(ticket.messages) && ticket.messages.length > 0) {
          // As mensagens já vêm ordenadas por createdAt DESC (mais recente primeiro)
          const lastMessage = ticket.messages[0];
          return lastMessage.fromMe === false;
        }
        
        // 3️⃣ Se não conseguiu determinar, não incluir no card (segurança)
        return false;
      };
      
      const noResponseTickets = tickets.filter((ticket) => {
        // Verifica se é um ticket com usuário (não pending)
        if (!ticket.user) return false;
        
        // ✅ CRÍTICO: Verificar se a última mensagem foi DO CLIENTE
        // Usa a função helper que verifica tanto o campo do ticket quanto o array de mensagens
        if (!isLastMessageFromClient(ticket)) {
          return false;
        }
        
        // Verifica se passou mais de 30 minutos desde a última atualização
        const lastUpdate = parseISO(ticket.updatedAt);
        const minutesSinceLastUpdate = differenceInMinutes(now, lastUpdate);
        
        return minutesSinceLastUpdate >= 30;
      });

      if (noResponseTickets.length === 0) return null;

      return (
        <Grid item>
          <div className={classes.main}>
            <div padding={2} className={classes.changeWarap}>
              <Paper elevation={3} className={classes.cardHeaderNoResponse}>
                <CardHeader
                  style={{ maxWidth: "380px", width: "100%" }}
                  avatar={<Avatar style={{ backgroundColor: "#FF6B6B" }}><AccessAlarm /></Avatar>}
                  title={
                    <span>
                      {`Sem Resposta (+30min)`}
                      <ReportProblem className={classes.noResponse} />
                      <div>
                        {i18n.t("momentsUser.services")}{" "}
                        {noResponseTickets?.length}
                      </div>
                    </span>
                  }
                />
              </Paper>
              <Paper square elevation={1} className={classes.card}>
                {noResponseTickets && Array.isArray(noResponseTickets) && noResponseTickets.map((ticket) => {
                  const lastUpdate = parseISO(ticket.updatedAt);
                  const minutesSinceLastUpdate = differenceInMinutes(now, lastUpdate);
                  const hoursAgo = Math.floor(minutesSinceLastUpdate / 60);
                  const minutesAgo = minutesSinceLastUpdate % 60;
                  
                  let timeAgoText = "";
                  if (hoursAgo > 0) {
                    timeAgoText = `${hoursAgo}h ${minutesAgo}min atrás`;
                  } else {
                    timeAgoText = `${minutesAgo}min atrás`;
                  }

                  return (
                    <List style={{ paddingTop: 0 }} key={ticket.id}>
                      <ListItem dense button>
                        <ListItemAvatar>
                          <Avatar
                            alt={`${ticket.contact.urlPicture}`}
                            src={`${ticket.contact.urlPicture}`}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          disableTypography
                          primary={
                            <span>
                              {ticket?.contact?.name?.length > 30
                                ? ticket?.contact?.name.substring(0, 25) + "..."
                                : ticket?.contact?.name}
                              <Typography style={{ fontSize: "0.75em", color: "#FF6B6B", fontWeight: "bold" }}>
                                {timeAgoText}
                              </Typography>
                            </span>
                          }
                          secondary={
                            <Fragment>
                              <div>
                                <Typography
                                  style={{ display: "inline" }}
                                  component="span"
                                  variant="body2"
                                >
                                  {`${
                                    ticket.lastMessage?.length > 30
                                      ? String(ticket.lastMessage).substring(
                                          0,
                                          27
                                        ) + "..."
                                      : ticket.lastMessage
                                  }`}
                                </Typography>
                              </div>
                              <div>
                                <Badge className={classes.connectionTag}>
                                  {ticket?.whatsapp?.name}
                                </Badge>
                                <Badge
                                  style={{
                                    backgroundColor:
                                      ticket.queue?.color || "#7c7c7c",
                                  }}
                                  className={classes.connectionTag}
                                >
                                  {ticket.queue?.name.toUpperCase() ||
                                    `${i18n.t("momentsUser.noqueue")}`}
                                </Badge>
                                {ticket.user && (
                                  <Badge
                                    style={{
                                      backgroundColor: "#2196F3",
                                    }}
                                    className={classes.connectionTag}
                                  >
                                    {ticket.user.name}
                                  </Badge>
                                )}
                              </div>
                            </Fragment>
                          }
                        />
                        <Typography
                          className={
                            Number(ticket.unreadMessages) > 0
                              ? classes.lastMessageTimeUnread
                              : classes.lastMessageTime
                          }
                          component="span"
                          variant="body2"
                        >
                          {isSameDay(parseISO(ticket.updatedAt), new Date()) ? (
                            <>{format(parseISO(ticket.updatedAt), "HH:mm")}</>
                          ) : (
                            <>
                              {format(parseISO(ticket.updatedAt), "dd/MM/yyyy")}
                            </>
                          )}
                        </Typography>
                        {(user.profile === "admin" ||
                          ticket.userId === user.id) && (
                          <>
                            <Tooltip title="Transferir Ticket">
                              <SwapHoriz
                                onClick={() => handleOpenTransferModal(ticket)}
                                fontSize="small"
                                style={{
                                  color: grey[500],
                                  cursor: "pointer",
                                  marginRight: 5,
                                  bottom: "-15px",
                                }}
                              />
                            </Tooltip>
                            <Tooltip title="Visualizar Mensagens">
                              <VisibilityOutlined
                                onClick={() => handleOpenViewTicketModal(ticket.id)}
                                fontSize="small"
                                style={{
                                  color: grey[500],
                                  cursor: "pointer",
                                  marginRight: 5,
                                  bottom: "-15px",
                                }}
                              />
                            </Tooltip>
                          </>
                        )}
                      </ListItem>
                      <Divider variant="inset" component="li" />
                    </List>
                  );
                })}
              </Paper>
            </div>
          </div>
        </Grid>
      );
    } else {
      return null;
    }
  }, [tickets, update, user.profile]);

  return (
    <Fragment>
      <Grid container spacing={2}>
        {MomentsNoResponse}
        {Moments}
        {MomentsPending}
      </Grid>
      
      {/* Modal de Transferência de Ticket Individual */}
      {selectedTicket && (
        <TransferTicketModalCustom
          modalOpen={transferTicketModalOpen}
          onClose={handleCloseTransferModal}
          ticketid={selectedTicket.id}
          ticket={selectedTicket}
        />
      )}

      {/* Modal de Transferência em Lote de Todos os Tickets do Usuário */}
      {selectedUserForBulkTransfer && (
        <BulkTransferUserTicketsModal
          open={bulkTransferModalOpen}
          onClose={handleCloseBulkTransferModal}
          userId={selectedUserForBulkTransfer.id}
          userName={selectedUserForBulkTransfer.name}
          onSuccess={handleBulkTransferSuccess}
        />
      )}

      {/* Modal de Visualização de Mensagens */}
      <TicketViewOnlyModal
        open={viewTicketModalOpen}
        onClose={handleCloseViewTicketModal}
        ticketId={selectedTicketId}
      />
    </Fragment>
  );
};

export default DashboardManage;
